import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Input } from "../ui/input";
import { format } from "date-fns";

const formatDateSafe = (dateStr) => {
  if (!dateStr) return '-';
  try {
    const s = String(dateStr);
    const datePart = s.includes('T') ? s.split('T')[0] : s.split(' ')[0];
    const [y, m, d] = datePart.split('-').map(Number);
    if (!y || !m || !d) return '-';
    return format(new Date(y, m - 1, d), 'MMM d, yyyy');
  } catch { return '-'; }
};

const DATE_FIELDS = [
  { label: "Contract", key: "contract_date", testId: "edit-contract-date" },
  { label: "EM Due Date", key: "earnest_money_deadline", testId: "edit-em-due-date" },
  { label: "Closing", key: "closing_date", testId: "edit-closing-date" },
  { label: "Inspection", key: "inspection_deadline" },
  { label: "Financing", key: "financing_deadline" },
  { label: "Insurance", key: "insurance_deadline" },
  { label: "Possession", key: "possession_date" },
];

export const KeyDatesPanel = ({ transaction, isEditing, editData, setEditData }) => (
  <Card className="card-surface" data-testid="key-dates-card">
    <CardHeader className="border-b border-[var(--t-border)] py-4 px-5">
      <CardTitle className="text-lg font-semibold text-[var(--t-text)] [font-family:var(--t-heading-font)]">
        Key Dates
      </CardTitle>
    </CardHeader>
    <CardContent className="p-5">
      <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
        {DATE_FIELDS.map(({ label, key, testId }) => (
          <div key={key}>
            <p className="text-xs uppercase tracking-wider text-[var(--t-text-muted)] font-semibold mb-1">{label}</p>
            {isEditing ? (
              <Input
                type="date"
                value={editData[key] || ''}
                onChange={(e) => setEditData({ ...editData, [key]: e.target.value })}
                className="h-7 text-xs px-1.5"
                data-testid={testId}
              />
            ) : (
              <p className="text-sm font-medium text-[var(--t-text)]">
                {transaction[key] ? formatDateSafe(transaction[key]) : '-'}
              </p>
            )}
          </div>
        ))}
      </div>
    </CardContent>
  </Card>
);
